import React, { useContext } from 'react';

const defaultTheme = {
  '@layout-header-background': '#2B2839',
  '@layout-trigger-background': '@layout-header-background',
  '@menu-dark-submenu-bg': 'darken(@layout-header-background, 5%)',
};

const ThemeContext = React.createContext(defaultTheme);

export const getTheme = () => {
  return JSON.parse(localStorage.getItem('theme')) || defaultTheme;
};

export const setTheme = (theme) => {
  if (theme) {
    localStorage.setItem('theme', JSON.stringify(theme));
    applyTheme(theme);
  } else {
    localStorage.removeItem('theme');
  }
};

export const useTheme = () => {
  return useContext(ThemeContext);
};

export const applyTheme = (theme) => {
  const metaThemeColor = document.querySelector('meta[name=theme-color]');
  metaThemeColor.setAttribute('content', theme['@layout-header-background']);

  return window.less.modifyVars(theme);
};

export default ThemeContext;
